/* MAMÉ — Navigation par étapes — Horizon */
(function () {
  const etapesParProduit = new WeakMap();

  function trouverGroupes(picker) {
    return Array.from(
      picker.querySelectorAll(
        '.variant-picker__form > .variant-option'
      )
    );
  }

  function initialiser() {
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      const groupes = trouverGroupes(picker);

      if (groupes.length < 2) return;

      const conteneur = picker.parentElement;
      if (!conteneur) return;

      let navigation = Array.from(
        conteneur.children
      ).find(function (element) {
        return element.classList.contains('mame-navigation');
      });

      if (!navigation) {
        navigation = document.createElement('div');
        navigation.className = 'mame-navigation';

        navigation.style.cssText =
          'display:flex;align-items:center;' +
          'justify-content:space-between;' +
          'gap:12px;margin:20px 0;';

        navigation.innerHTML = `
          <button type="button" class="mame-precedent">
            ← Précédent
          </button>
          <span class="mame-compteur"></span>
          <button type="button" class="mame-suivant">
            Suivant →
          </button>
        `;
      }

      // Les boutons restent en dehors du sélecteur Horizon.
      if (navigation.previousElementSibling !== picker) {
        picker.insertAdjacentElement('afterend', navigation);
      }

      let etape = etapesParProduit.get(conteneur) || 0;
      etape = Math.min(etape, groupes.length - 1);

      const precedent = navigation.querySelector('.mame-precedent');
      const suivant = navigation.querySelector('.mame-suivant');
      const compteur = navigation.querySelector('.mame-compteur');

      function afficher() {
        groupes.forEach(function (groupe, index) {
          groupe.style.setProperty(
            'display',
            index === etape ? '' : 'none',
            'important'
          );
        });

        compteur.textContent =
          (etape + 1) + ' / ' + groupes.length;

        precedent.disabled = etape === 0;
        suivant.disabled = etape === groupes.length - 1;

        etapesParProduit.set(conteneur, etape);
      }

      precedent.onclick = function () {
        if (etape > 0) {
          etape--;
          afficher();
        }
      };

      suivant.onclick = function () {
        if (etape < groupes.length - 1) {
          etape++;
          afficher();
        }
      };

      afficher();
    });
  }

  let actualisationEnCours = false;

  function programmerActualisation() {
    if (actualisationEnCours) return;

    actualisationEnCours = true;

    requestAnimationFrame(function () {
      actualisationEnCours = false;
      initialiser();
    });
  }

  function demarrer() {
    initialiser();

    const observateur = new MutationObserver(function (mutations) {
      const changementStructure = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0 ||
               mutation.removedNodes.length > 0;
      });

      if (changementStructure) {
        programmerActualisation();
      }
    });

    observateur.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();